import { Controller } from "stimulus"

const BODY_CLASS = 'video-lightbox-modal-open'

export default class extends Controller {
  static targets = ['player']

  connect() {
    this.boundShow = this.onShow.bind(this)
    this.boundHidden = this.onHidden.bind(this)
    this.element.addEventListener('show.bs.modal', this.boundShow)
    this.element.addEventListener('hidden.bs.modal', this.boundHidden)
  }

  disconnect() {
    this.element.removeEventListener('show.bs.modal', this.boundShow)
    this.element.removeEventListener('hidden.bs.modal', this.boundHidden)
    document.body.classList.remove(BODY_CLASS)
    this.clearPlayer()
  }

  onShow(event) {
    document.body.classList.add(BODY_CLASS)

    const trigger = event.relatedTarget
    const url = trigger && trigger.dataset.videoUrl
    if (!url || !this.hasPlayerTarget) return

    this.playerTarget.src = url
  }

  onHidden() {
    document.body.classList.remove(BODY_CLASS)
    this.clearPlayer()
  }

  clearPlayer() {
    if (!this.hasPlayerTarget) return

    this.playerTarget.pause()
    this.playerTarget.removeAttribute('src')
    this.playerTarget.load()
  }
}
